import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { GridCentralPanelProps } from '../grid-types';
import { useGridBody } from '../grid-hooks';
import { GridTransitionButtons as DefaultGridTransitionButtons } from './transitionButtons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridCentralPanelRoot: {
      height: '100%',
    },
    gridCentralPanelBody: {
      padding: 15,
      paddingTop: 0,
    },
  })
);

export function GridCentralPanel(props: GridCentralPanelProps) {
  const classes = useStyles();
  const {
    gridBody,
    gridConfig,
    GridTransitionButtons = DefaultGridTransitionButtons,
    hideTransitionButtons,
  } = props;

  const GridBody = useGridBody(gridConfig, gridBody);

  return (
    <div className={classes.gridCentralPanelRoot}>
      {!hideTransitionButtons && <GridTransitionButtons {...props} />}
      <div
        className={classes.gridCentralPanelBody}
        style={{ paddingTop: hideTransitionButtons ? 15 : 0 }}
      >
        <GridBody {...props} />
      </div>
    </div>
  );
}
